import React from "react";

import {
  Box,
  Chip,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import Content from "@ds-developer/content";

const useStyles = makeStyles(theme => ({
  root: {
    background: "#3DC0DB",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 2000,
    },
  },
  chip: {
    background: theme.palette.background.paper,
    textTransform: "uppercase",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  title: {
    color: theme.palette.background.paper,
    lineHeight: "32px",
    fontSize: "16px",
    textTransform: "uppercase",
    fontWeight: 600,

    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
  subtitle: {
    fontSize: "16px",

    [theme.breakpoints.up("sm")]: {
      lineHeight: "28px",
    },

    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  container: {
    paddingLeft: theme.spacing(2),
    flex: 1,

    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
}));

type ExperimentBannerProps = {
  closeBanner?: () => void;
  showBanner?: boolean;
};

const ExperimentBanner: React.FC<ExperimentBannerProps> = ({
  closeBanner = () => {},
  showBanner = false,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  if (!showBanner) return null;

  return (
    <div className={classes.root} onClick={closeBanner}>
      <Content noTopSpacing noBottomSpacing>
        <Grid container direction="row">
          <Chip className={classes.chip} label="BETA" />
          <Box className={classes.container}>
            <Typography className={classes.title}>
              This site is in experiment mode
            </Typography>
            <Typography className={classes.subtitle}>
              You can browse around to familiarise yourself with the new layout
              and functions.
              {!isMobile ? <br /> : " "}
              No changes you make will be saved, Hubcapp will be reset
              overnight.
            </Typography>
            <CloseIcon
              style={{ position: "absolute", top: "20px", right: "10px" }}
            />
          </Box>
        </Grid>
      </Content>
    </div>
  );
};

export default ExperimentBanner;
